var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.8075 0.32874C8.0055 0.208535 3.992 0.209024 2.1925 0.32874C0.244 0.458717 0.0145 1.60897 0 4.63656C0.0145 7.65877 0.242 8.81391 2.1925 8.94438C3.9925 9.06409 8.0055 9.06458 9.8075 8.94438C11.756 8.8144 11.9855 7.66415 12 4.63656C11.9855 1.61434 11.758 0.459206 9.8075 0.32874ZM4.5 6.5911V2.68201L8.5 4.63314L4.5 6.5911Z","fill":"#1A1D31"}));
}

Youtube.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
